module.exports = __webpack_public_path__ + "6b15ee168769bd118ec5384938415cd0.jpg";